<!--
  @Description: 
  @Author: wang.y 
  @Date: 2024-01-30 
-->
<template>
  <div class="container">
    <div class="container-top">
      <div class="title">
        <img src="~img/logo/vb100.png" />
        <p>小程序券码核销系统</p>
      </div>
      <Button @click="$router.go(-1)">返回</Button>
    </div>
    <div class="theme-title">核销记录</div>
    <div class="theme-select">
      <div :class="['select-item']">
        <div class="select-title">活动</div>
        <Select v-model="currentActivityId" @on-change="selectActivity" clearable>
          <Option v-for="item in activityDtoList" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
      </div>
      <div :class="['select-item']" v-if="currentActivityItem.type == 2">
        <div class="select-title">论坛</div>
        <Select v-model="currentSubActivityId" @on-change="selectSub" clearable>
          <Option v-for="item in subList" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
      </div>
    </div>
    <div class="main-container">
      <div class="table-top">
        <div class="number">
          <span class="spa1">已核销：</span>
          <span class="spa2">{{total}}</span>
          <span class="spa3">人</span>
        </div>
        <div>
          <Select v-model="listParam.sortType" style="width:100px" size="small" @on-change="handleChangeSort">
            <Option :value="1">倒序</Option>
            <Option :value="2">正序</Option>
          </Select>
        </div>
      </div>
      <div class="table-container">
        <Table :columns="recordColumns" :data="list">
          <template slot-scope="{ row }" slot="name">
            <a class="hover-a" @click="lookDetail(row.id)">{{row.name}}</a>
          </template>
          <template slot-scope="{ row }" slot="ticketType">
            {{row.ticketType | dealNeed(ticketTypes)}}
          </template>
        </Table>
        <div class="table-page" v-if="total > 10">
          <Page :total="total" :page-size="10" class="page-list" show-total show-elevator :current="listParam.page" @on-change="handleChangePage" />
        </div>
      </div>
    </div>
    <cancelDetail ref="cancelDetail"></cancelDetail>
  </div>
</template>
<script>
import { recordlist, mainActivitylist, subActivitylist } from '@/service/main.js'
import cancelDetail from '@/components/cancelDetail'
export default {
  components: {
    cancelDetail
  },
  created() {
    this.getRecordlist()
    this.mainActivitylist()
  },
  mounted() {},
  data() {
    return {
      ticketTypes: [
        { id: 1, name: '付费票' },
        { id: 2, name: '免费票' },
        { id: 3, name: '赠送票' },
        { id: 4, name: '第三方售卖' },
      ],
      listParam: {
        activityId: this.$route.params.id,
        page: 1,
        size: 10,
        sortType: 1,
      },
      recordColumns: [
        {
          title: '核销序号',
          width: 100,
          key: 'id',
        },
        {
          title: '姓名',
          width: 140,
          slot: 'name',
        },
        {
          title: '手机号',
          width: 180,
          key: 'mobile',
        },
        {
          title: '票种',
          minWidth: 160,
          key: 'activityTicketTitle',
        },
        {
          title: '类型',
          width: 100,
          slot: 'ticketType',
        },
        {
          title: '核销时间',
          width: 200,
          key: 'createTime',
        },
        {
          title: '操作人',
          width: 160,
          key: 'verificationUserName',
        },
      ],
      list: [],
      total: 0,
      msgArr: [
        { id: 1, name: '核销成功' },
        { id: 2, name: '门票错误<br/>非本论坛票' },
        { id: 3, name: '已被核销' },
      ],
      activityDtoList: [],
      currentActivityId: '',
      currentActivityItem: {},
      subList: [],
      currentSubActivityId: '',
      validStatus: 0,
    }
  },
  computed: {},
  methods: {
    async getRecordlist() {
      let res = await recordlist(this.listParam)
      if (res.code == 0) {
        this.$set(this.$data, 'list', res.data.writeOffRecordDtoList)
        if (this.listParam.page == 1) this.$set(this.$data, 'total', res.data.count)
      } else {
        this.$Message.error(res.msg)
      }
    },
    handleChangePage(value) {
      this.listParam.page = value
      this.getRecordlist()
    },
    handleChangeSort(value) {
      this.listParam.sortType = value
      this.listParam.page = 1
      this.getRecordlist()
    },
    async mainActivitylist() {
      let res = await mainActivitylist({})
      if (res.code == 0) {
        this.$set(this.$data, 'activityDtoList', res.data.activityDtoList)
      } else {
        this.$Message.error(res.msg)
      }
    },
    async subActivitylist(mainId) {
      let res = await subActivitylist({
        mainId,
      })
      if (res.code == 0) {
        this.$set(this.$data, 'subList', res.data)
      } else {
        this.$Message.error(res.msg)
      }
    },
    selectActivity(value) {
      this.listParam.activityId = value
      this.handleChangePage(1)
      this.currentSubActivityId = ''
      if(!value) {
        this.currentActivityItem = {}
        return
      }
      this.currentActivityItem = this.activityDtoList.find((a) => a.id == value)
      if (this.currentActivityItem.type != 1) {
        this.subActivitylist(value)
      }
    },
    selectSub(value) {
      this.listParam.activityId = value
      this.handleChangePage(1)
    },
    lookDetail(rowId) {
      this.$refs['cancelDetail'].getDetail(rowId)
    }
  },
}
</script>
<style lang='stylus' scoped>
.container
  width 1200px
  min-height 100vh
  margin 0 auto
  padding-top 50px
  .container-top
    display flex
    align-items center
    .title
      img
        width 90px
        height 25px
      p
        font-size 20px
        font-weight 500
        color #B3B5B5
        line-height 1
        margin-top 12px
    .ivu-btn-default
      width 60px
      height 35px
      border 2px solid #333333
      border-radius 6px
      font-size 16px
      font-weight bold
      color #333333
      padding 0
      margin-left 40px
  .theme-title
    font-size 30px
    font-weight bold
    line-height 44px
    margin-top 30px
    color #333333
  .theme-select
    display flex
    align-items center
    margin-top 30px
    .select-item
      position relative
      margin-bottom 40px
      &+.select-item
        margin-left: 10px
    .select-title
      position absolute
      height 16px
      font-size 16px
      color #333333
      line-height 1
      padding 0 6px
      background #fff
      z-index 2
      top -7px
      left 30px
    >>> .ivu-select
      width 480px
      .ivu-select-selection
        border-color #CCC
        height 60px
        .ivu-select-placeholder, .ivu-select-selected-value
          height 58px
          line-height 58px
          font-size 18px
          padding-left 30px
          padding-right 40px
        .ivu-select-selected-value
          color #333
      .ivu-select-arrow
        font-size 18px
        color #333
      .ivu-select-item
        color #333
        padding 10px 20px
        font-size 18px !important
.main-container
  .table-top
    display flex
    align-items center
    justify-content space-between
    .number
      .spa1
        color #2E6BF7
        font-size 14px
      .spa2
        color #FC3B3B
        font-size 30px
      .spa3
        color #333
        font-size 14px
  .table-container
    margin-top 4px
    >>> .ivu-table-wrapper
      width 100%
      .ivu-table 
        .ivu-table-cell
          padding-left 10px
          padding-right 10px
          font-size 14px
          .hover-a
            color #2E6BF7
            cursor pointer
  .table-page
    margin-top 20px
    text-align center
</style>